import { Link, NavLink, useLocation } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { Languages } from "lucide-react";

const HouseMark = () => (
  <span className="flex items-end gap-[3px] h-7" aria-hidden="true">
    {[14, 22, 28, 18, 26, 12].map((h, i) => (
      <span
        key={i}
        className={`w-[5px] rounded-t-sm ${i === 2 ? "bg-primary" : "bg-primary/35"}`}
        style={{ height: `${h}px` }}
      />
    ))}
  </span>
);

export const Header = () => {
  const { t, toggleLang, lang } = useLanguage();
  const location = useLocation();

  const links = [
    { to: "/", label: t.nav.support, testid: "nav-support-link" },
    { to: "/about", label: t.nav.about, testid: "nav-about-link" },
    { to: "/privacy", label: t.nav.privacy, testid: "nav-privacy-link" },
  ];

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-white/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-x-6 gap-y-2 px-5 py-3 sm:px-8">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-home-link">
          <HouseMark />
          <span className="leading-tight">
            <span className="block text-base font-extrabold text-foreground">{t.brand.name}</span>
            <span className="block text-[11px] font-medium text-muted-foreground">{t.brand.tag}</span>
          </span>
        </Link>

        <nav className="flex items-center gap-1 sm:gap-2" aria-label="Primary" data-testid="primary-nav">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              data-testid={link.testid}
              aria-current={location.pathname === link.to ? "page" : undefined}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-semibold transition-colors duration-200 ${
                  isActive
                    ? "bg-accent text-primary"
                    : "text-muted-foreground hover:bg-secondary hover:text-foreground"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <button
            type="button"
            onClick={toggleLang}
            data-testid="language-switcher-button"
            aria-label={lang === "ar" ? "Switch to English" : "التبديل إلى العربية"}
            className="ms-2 inline-flex items-center gap-2 rounded-full border border-primary/30 px-4 py-2 text-sm font-bold text-primary transition-colors duration-200 hover:bg-primary hover:text-primary-foreground"
          >
            <Languages className="h-4 w-4" aria-hidden="true" />
            {t.otherLang}
          </button>
        </nav>
      </div>
    </header>
  );
};
